/* eslint-disable no-unused-expressions */
/* eslint-disable import/prefer-default-export */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React, { useMemo, useRef } from 'react'
import { FixedSizeList as List } from 'react-window'
import clsx from 'clsx'
import { useMedia } from 'hooks/useMedia'
import { DropdownRow } from '../DropdownRow'
import { MOBILE_HEADER_OFFSET, DEFAULT_PROPS, MOBILE_BREAKPOINT } from '../../consts'
import { filterOptionsBySearch } from '../../utils/dropdownUtils'
import styles from './DropdownPanel.module.css'
import { SearchIcon } from './SearchIcon'
import { CloseIcon } from './CloseIcon'

export const DropdownPanel = ({
  // Options and data
  filteredOptions,
  selectedValues,
  collapsed,

  // Search functionality
  search,
  onSearchChange,
  inputPlaceholder = DEFAULT_PROPS.inputPlaceholder,

  // Actions
  onToggleValue,
  onToggleCollapse,
  onApply,
  onViewSelected,
  onClose,

  // View state
  viewSelectedMode = false,

  // Styling and behavior
  itemHeight = DEFAULT_PROPS.itemHeight,
  maxVisibleItems = DEFAULT_PROPS.maxVisibleItems,
  className,

  // Refs for external control
  listRef: externalListRef,
  panelRef: externalPanelRef,
}) => {
  const internalListRef = useRef(null)
  const internalPanelRef = useRef(null)
  const isMobile = useMedia([MOBILE_BREAKPOINT], [true], false)

  const listRef = externalListRef || internalListRef
  const panelRef = externalPanelRef || internalPanelRef

  const displayOptions = useMemo(() => {
    if (!search) return filteredOptions
    return filterOptionsBySearch(filteredOptions, search).filteredOptions
  }, [filteredOptions, search])

  const itemData = useMemo(
    () => ({
      filteredOptions: displayOptions,
      selectedValues,
      toggleValue: onToggleValue,
      toggleCollapse: onToggleCollapse,
      collapsed,
    }),
    [displayOptions, selectedValues, onToggleValue, onToggleCollapse, collapsed]
  )

  const handleSearchChange = (e) => {
    onSearchChange?.(e.target.value)
  }

  const handleApply = () => {
    onApply?.()
  }

  const handleViewSelected = () => {
    onViewSelected?.()
  }

  const handleClose = () => {
    onClose?.()
  }

  return (
    <div className={clsx(styles.dropdownPanel, className)} ref={panelRef} role="listbox">
      <div className={styles.mobileHeader}>
        <div className={styles.mobileHeaderName}>{inputPlaceholder}</div>
        <button type="button" className={styles.mobileClose} onClick={handleClose} aria-label="Close dropdown">
          <CloseIcon />
        </button>
      </div>

      <div className={styles.searchBar}>
        <SearchIcon />
        <input
          placeholder={inputPlaceholder}
          value={search || ''}
          onChange={handleSearchChange}
          className={styles.triggerInput}
          autoComplete="off"
          role="searchbox"
          aria-label="Search options"
        />
      </div>

      {displayOptions.length > 0 ? (
        <List
          ref={listRef}
          height={
            isMobile
              ? window.innerHeight - MOBILE_HEADER_OFFSET
              : Math.min(displayOptions.length, maxVisibleItems) * itemHeight
          }
          itemCount={displayOptions.length}
          itemSize={itemHeight}
          width="100%"
          itemData={itemData}
        >
          {DropdownRow}
        </List>
      ) : (
        <div className={styles.noResults} role="status">
          No Results
        </div>
      )}

      <div className={styles.footer}>
        <button
          className={clsx(styles.viewSelectedButton, selectedValues.length > 0 && styles.viewSelectedButtonActive)}
          type="button"
          onClick={handleViewSelected}
          disabled={selectedValues.length === 0 && !viewSelectedMode}
        >
          {viewSelectedMode ? 'Clear All' : 'View Selected'}
        </button>

        <div className={styles.divider} />

        <button className={styles.applyButton} type="button" onClick={handleApply}>
          Apply {selectedValues.length > 0 && `(+${selectedValues.length})`}
        </button>
      </div>
    </div>
  )
}
